import { render, staticRenderFns } from "./CourseView.vue?vue&type=template&id=1c25e8a4&scoped=true&"
import script from "./CourseView.vue?vue&type=script&lang=js&"
export * from "./CourseView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c25e8a4",
  null
  
)

export default component.exports